import { useState, useEffect, useRef } from "react";

const POLL_INTERVAL_MS = 5 * 60 * 1000;
export const UPDATE_AVAILABLE_STORAGE_KEY = "suiviQualite.updateAvailableVersion";

function getStoredUpdateVersion() {
    try {
        return globalThis.localStorage?.getItem(UPDATE_AVAILABLE_STORAGE_KEY) ?? null;
    } catch {
        return null;
    }
}

function storeUpdateVersion(version) {
    try {
        globalThis.localStorage?.setItem(UPDATE_AVAILABLE_STORAGE_KEY, version);
    } catch {
        // localStorage can be unavailable in private or restricted browser modes.
    }
}

export function clearStoredUpdateVersion() {
    try {
        globalThis.localStorage?.removeItem(UPDATE_AVAILABLE_STORAGE_KEY);
    } catch {
        // Keep the update action usable even when browser storage is blocked.
    }
}

async function fetchVersion() {
    const res = await fetch("/version.json", { cache: "no-store" });
    if (!res.ok) return null;
    const data = await res.json();
    return data.version ?? null;
}

export function useVersionCheck() {
    const [updateAvailable, setUpdateAvailable] = useState(() => Boolean(getStoredUpdateVersion()));
    const initialVersion = useRef(null);

    useEffect(() => {
        fetchVersion().then(v => { initialVersion.current = v; });

        const interval = setInterval(async () => {
            const current = await fetchVersion();
            if (current && initialVersion.current && current !== initialVersion.current) {
                storeUpdateVersion(current);
                setUpdateAvailable(true);
            }
        }, POLL_INTERVAL_MS);

        return () => clearInterval(interval);
    }, []);

    return updateAvailable;
}
